import { getFromApiFunction } from "../apiFunctions";

const getPole = async (params: URLSearchParams = new URLSearchParams()) => {
  const endPoint = "/poles/";
  return getFromApiFunction(endPoint, params);
};

export { getPole };
